export default {
	"火蚁联盟": "FireAnt Alliance",
	"娱乐经济的能量核心": "The Energy Core of the Entertainment Economy",
	"节点订阅系统": "Node Subscription System",
	"推荐人：": "Referrer:",
	"首页": "Home",
	"NFT卡牌": "NFT",
	"我的邀请链接（点击复制）": "My Invitation Link (Click to Copy)",
	"初级节点": "Basic Node",
	"高级节点": "Advanced Node",
	"獲得全網NFT新增業績2.5%分紅": "Earn 2.5% Dividend from Network NFT Performance",
	"获得4倍代币燃料值": "Earn 4x Token Fuel Value",
	"获得5倍代币燃料值": "Earn 5x Token Fuel Value",
	"获得娱乐游戏平台收益的5%分红": "Earn 5% Dividend from Entertainment Platform",
	"获得每日产出FAC代币2%分配": "Earn 2% of Daily FAC Token Output",
	"请连接钱包": "Please Connect Wallet",
	"USDT余额不足": "Insufficient USDT Balance",
	"转账已发起": "Transfer Initiated",
	"转账被取消": "Transfer Cancelled",
	"取消": "Cancel",
	"未连接钱包": "Wallet Not Connected",
	"复制成功": "Copied Successfully",
	"订单记录": "Order History",
	"我的社群": "My Community",
	"节点预售": "Node Presale",
	"我的订单": "My Orders",
	"创建时间：": "Created:",
	"转账哈希：": "Transaction Hash:",
	"购买初级节点": "Purchase Basic Node",
	"购买高级节点": "Purchase Advanced Node",
	"空": "Empty",
	"獲得算力挖礦": "Earn Mining Hashrate",
	"已购买": "Purchased",
	"獲得DAO投票權限": "Earn DAO Voting Rights",
	"付款地址：": "Payment Address:",
	"節點類型：": "Node Type:",
	"获取中": "Loading",
	"交易中": "Processing",
	"金额：": "Amount:",
	"推荐地址：": "Referral Address:",
	"推荐时间：": "Referral Time:",
	"社群总业绩 U：": "Total Community Performance U:",
	"社群总地址 个：": "Total Community Addresses:",
	"确认绑定?": "Confirm Binding?",
	"确定": "Confirm",
	"操作成功": "Operation Successful",
	"操作失败": "Operation Failed",
	"获取数据失败": "Failed to Fetch Data",
	"授权成功": "Authorization Successful",
	"授权失败": "Authorization Failed",
	"操作中": "Processing",
	"进入共振": "Enter Resonance",
	"赎回": "Redeem",
	"领取奖励": "Claim Rewards",
	"开始共振": "Start Resonance",
	"共振中，距离共振结束还有": "Resonating, Time Remaining:",
	"NFT已经失效": "NFT Expired",
	"超时，NFT即将失效": "Timeout, NFT About to Expire",
	"共振未开始": "Resonance Not Started",
	"赎回共振金": "Redeem Resonance Funds",
	"共振结束": "Resonance Ended",
	"详情": "Details",
	"次数：": "Count:",
	"算力：": "Hashrate:",
	"燃料：": "Fuel:",
	"剩余用能量：": "Remaining Energy:",
	"总能量：": "Total Energy:",
	"类型：": "Type:",
	"参与共振流动性": "Participate in Resonance Liquidity",
	"加载中": "Loading",
	"未开始": "Not Started",
	"共振中": "Resonating",
	"异常": "Error",
	"USD资产": "USD Assets",
	"FAC资产": "FAC Assets",
	"NFT卡牌：": "NFT Cards:",
	"共振金：": "Resonance Deposit:",
	"总收益：": "Total Earnings:",
	"共振奖励：": "Resonance Rewards:",
	"直推奖励：": "Direct Referral Rewards:",
	"层级奖励：": "Level Rewards:",
	"社区奖励：": "Community Rewards:",
	"节点分红：": "Node Dividends:",
	"已领取：": "Claimed:",
	"我的算力：": "My Hashrate:",
	"我的燃料：": "My Fuel:",
	"我的矿池：": "My Mining Pool:",
	"已释放FAC：": "Released FAC:",
	"社区奖励FAC：": "Community Reward FAC:",
	"节点分红FAC：": "Node Dividend FAC:",
	"平台分红FAC：": "Platform Dividend FAC:",
	"可领取FAC：": "Claimable FAC:",
	"已领取FAC：": "Claimed FAC:",
	"领取": "Claim",
	"没有可提取的FAC": "No FAC Available to Claim",
	"没有可用的能量": "No Energy Available",
	"参数获取失败": "Failed to Get Parameters",
	"领取成功": "Claimed Successfully",
	"共振奖励提取成功": "Resonance Rewards Claimed Successfully",
	"共振奖励提取失败": "Failed to Claim Resonance Rewards",
	"层级奖励提取成功": "Level Rewards Claimed Successfully",
	"NFT价格": "NFT Price",
	"数量": "Quantity",
	"总价": "Total Price",
	"账户余额": "Account Balance",
	"购买NFT": "Purchase NFT",
	"推荐地址": "Referral Address",
	"我的邀请链接": "My Invitation Link",
	"复制邀请链接": "Copy Invitation Link",
	"购买失败": "Purchase Failed",
	"购买成功": "Purchase Successful",
	"我的资产": "My Assets",
	"提取": "Withdraw",
	"节点认购": "Node subscription",
	"时": "hours",
	"分": "minutes",
	"秒": "seconds",
	"可领取：": "Available to claim:",
	"我的能量：": "My energy:",
	"推荐钱包：": "Recommended wallet:",
	"确认绑定？": "Confirm binding?",
	"火蚁联盟将于{time}后启动。": "Fire Ant Alliance will launch in {time}.",
	"本操作将在24小时公测期后开放": "This operation will be available after the 24-hour public testing period",
	"暂未开放": "Not Yet Available",
	"请使用分享链接打开。": "Please open using the share link.",
	"Fire Ant Alliance邀请您参与我们的多签。": "Fire Ant Alliance Multisig Invitation. Please review and sign this transaction",
	"操作过于频繁": "Too many requests",
	"社区奖励提取成功": "Community Reward Withdrawal Successful",
	"已释放节点分红FAC：": "Released Node Dividend FAC:",
	"社群NFT总地址 个：": "Total Community NFT Addresses:",
	"NFT业绩 U：": "NFT Commission:",
	"节点分红释放FAC：": "Node Dividend Released FAC:",
	"矿池释放FAC：": "Mining Pool Released FAC:",
	"无剩余能量": "No remaining energy",
}